var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tabs-maneuvering-data"}},[_c('vs-tabs',{attrs:{"vs-alignment":"fixed","alignment":"fixed","color":_vm.sdfColor.LightGreen}},[_c('vs-tab',{attrs:{"label":"動静データ"}},[_c('tab-status')],1),_c('vs-tab',{attrs:{"label":"操船データ"}},[_c('tab-maneuvering')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }